module.exports = __webpack_public_path__ + "img/header-diamondJewelryEarrings@2x.6ed2ae5.jpg";